import { useEffect } from 'react'

import { useAppSelector } from '../../../redux/hooks'
import { CustomerlySettingsType } from '../customerlyTypes'
import { customerlyInit } from '../init'

const AppIdDev: {
  [key: string]: string
} = {
  fic: 'f08a1a94',
  dic: '5d5a88a5',
  resellers: 'b5e5582e',
}

const AppIdDicSpain = 'fef550a9'

const AppIdProduction: {
  [key: string]: string
} = {
  fic: '0042cd2c',
  dic: '01151122',
  resellers: '0042cd2c',
}

const useCustomerlyInit = (): void => {
  const realm = useAppSelector((state) => state.realm.value)
  const language = useAppSelector((state) => state.locale.value)
  const { openable, singleConversation } = useAppSelector(
    (state) => state.chat.config
  )
  const info = useAppSelector((state) => state.chat.info)
  const isVisible = useAppSelector((state) => state.chat.visible)
  const authInfo = useAppSelector((state) => state.auth)

  useEffect(() => {
    const uid = String(authInfo.isAuth ? authInfo.companyId ?? info.company.id : '')
    const peid = String(authInfo.isAuth ? authInfo.personId ?? info.person.id : '')
    const is_dic = realm === 'dic' || realm === 'dic-es'
    const customerlySettings: CustomerlySettingsType = {
      // TODO check for DIC-es move dic checks to variable and add dic es
      widget_hide_mobile: is_dic,
      app_id: is_dic && language.toLowerCase().startsWith('es') ? AppIdDicSpain :
        process.env.REACT_APP_ENV === 'production'
          ? AppIdProduction[realm]
          : AppIdDev[realm],
      singleConversation: singleConversation,
      autodetectLocale: true,
      language: language ?? 'it',
      user_id: peid,
      email: authInfo.isAuth ? info?.person.email : null,
      name: authInfo.isAuth ? info?.person.name : null,
      email_hash: authInfo.isAuth ? info?.attributes.email_hash : null,
      company: authInfo.isAuth && info ? {
        company_id: uid,
        link: (process.env.ADMIN_URL ?? 'https://admin.madbit.it') + '/utenti' + (is_dic ? 'Dic' : 'Fic') + '?uid=' + uid,
        name: info.company.name,
        license_expire: is_dic ? info.services.dic.expire : info.services.fic.expire,
        license_expire_at: +new Date(is_dic ? info.services.dic.expire : info.services.fic.expire) / 1000,
        accountant: info.attributes.is_accountant,
        created_at: +new Date(is_dic ? info.services.dic.signup : info.services.fic.signup) / 1000,
        registration_service: info.services.registration_service,
        fic: info.services.fic.active,
        dic: info.services.dic.active,
        dic_license_expire: info.services.dic.expire < new Date().toISOString().substring(0, 10),
        dic_plan: String(info.services.dic.plan),
        dic_signup_date: info.services.dic.signup,
      } : null,
      attributes: authInfo.isAuth && info ? {
        is_admin: info.attributes.is_admin,
        is_subuser: info.attributes.is_user,
        is_employee: info.attributes.is_employee,
        is_through_accountant: info.attributes.is_through_accountant,
        plan: String(is_dic ? info.services.dic.plan : info.services.fic.plan),
        superaccount: info.attributes.is_accountant,
        license_expire_at: +new Date(is_dic ? info.services.dic.expire : info.services.fic.expire) / 1000,
        created_at: is_dic ? info.services.dic.signup : info.services.fic.signup,
        privacy_info: info.privacy ? info.privacy.info ?? '' : '',
        privacy_offers: info.privacy ? info.privacy.offers ?? '' : '',
        privacy_surveys: info.privacy ? info.privacy.surveys ?? '' : '',
        privacy_third: info.privacy ? info.privacy.third ?? '' : '',
      } : null,
    }
    const script = document.querySelector<HTMLScriptElement>(
      `script[src^="https://messenger.customerly.io/launcher.js"]`
    )
    if (!script) {
      customerlyInit()
      window.customerly?.load(customerlySettings)
    } else {
      window.customerly?.update(customerlySettings)
    }
    if (openable || !authInfo.isAuth) {
      if (!isVisible) {
        window.customerly?.close()
      } else {
        window.customerly?.open()
      }
    } else {
      window.customerly?.hide()
    }
  }, [info, isVisible, openable, singleConversation, language, authInfo])
}

export default useCustomerlyInit
